<template>
  <div>
      <flash-message
          v-if="messages.success?.length > 0"
          type="success"
          :message="messages.success"
          @reset="messages.success = []
            "/>
      <flash-message
          v-if="messages.error?.length > 0"
          type="error"
          :message="messages.error"
          @reset="messages.error = []"
      />
      <flash-message
          v-if="messages.info?.length > 0"
          type="info"
          :message="messages.info"
          @reset="messages.info = []"
      />
  </div>
</template>

<script>
import FlashMessage from "./FlashMessage.vue";
export default {
    components: {
        FlashMessage
    },
    props: {
        messages: {
            type: Object,
            default: () => { return { error: [], success: [], info: [] } }
        }
    }
}
</script>
